import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import concurrentsSlice from './features/concurrents/concurrentsSlice';
import quizSlice from './features/quiz/quizSlice';
import loginSlice from './features/users/loginSlice';
import manageUsersSlice from './features/users/manageUsersSlice';
import userInfoSlice from './features/users/userInfoSlice';
import websitesSlice from './features/websites/websitesSlice';
import subscriptionSlice from './features/forfait/forfaitSlice';
import tourSlice from './features/tour/tourSlice';

export const store = configureStore({
  reducer: {
    login: loginSlice,
    userInfo: userInfoSlice,
    users: manageUsersSlice,
    quiz: quizSlice,
    websites: websitesSlice,
    concurrents: concurrentsSlice,
    subscriptions: subscriptionSlice,
    tour: tourSlice
  },
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) => {
    if (process.env.NODE_ENV !== 'production')
      return getDefaultMiddleware({
        serializableCheck: false
      }).concat(logger)
    return getDefaultMiddleware({
      serializableCheck: false
    })
  }
});
